var CrossPromotionWidget = /** @class */ (function () {
    function CrossPromotionWidget() {
        this.init();
    }
    CrossPromotionWidget.prototype.init = function () {
        // Initialize cross promotion widget functionality
        this.setupCrossPromotionLinks();
    };
    CrossPromotionWidget.prototype.setupCrossPromotionLinks = function () {
        // Add any cross promotion-specific JavaScript functionality here
        // For example, analytics tracking, hover effects, etc.
    };
    return CrossPromotionWidget;
}());
// Initialize cross promotion widgets when DOM is ready
export function initCrossPromotionWidgets() {
    var crossPromotionWidgets = document.querySelectorAll('.rmff-cross-promotion-widget');
    crossPromotionWidgets.forEach(function (widget) {
        new CrossPromotionWidget();
    });
}
// Export for use in main index.ts
window.CrossPromotionWidget = CrossPromotionWidget;
window.initCrossPromotionWidgets = initCrossPromotionWidgets;
